// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import packageInfo from '../../package.json';
import { EnvironmentType } from '../types/environment-type';

export const environment: EnvironmentType = {
  appVersion: packageInfo.version,
  production: false,
  apiUrl: 'https://api.v2.megarastreo.co',
  assets: {
    local: '',
    bucket: 'https://megarastreo.s3.us-west-2.amazonaws.com/system/'
  },
  googleMap: {
    apiKeys: ['AIzaSyDb4mhHS5uNuDMmLKCg4jHWr9GL68QAUvc', 'AIzaSyC5Xcxaut11RldxIidyvL8_4n85FyZe7YE']
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
